
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M24 2.8c0-.4-.3-.8-.6-1-.7-.5-1.6-.4-2.2.3L7.6 19.3l-.1.1c-.1.1-.2 0-.2 0s-.1 0-.2-.1l-4.3-6.1c-.2-.3-.6-.6-1-.6-.4-.1-.8 0-1.2.3-.3.2-.6.6-.6 1s0 .8.3 1.2l4.2 6c.5.7 1.3 1.3 2.2 1.4.2 0 .4.1.7.1.7 0 1.3-.2 1.9-.6.3-.2.6-.5.8-.7L23.7 4c.2-.4.3-.8.3-1.2z"}})])
          )
        }
      }
    